import { render, staticRenderFns } from "./ManualsSearch.vue?vue&type=template&id=63847566&"
import script from "./ManualsSearch.vue?vue&type=script&lang=ts&"
export * from "./ManualsSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports